



































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { LoggedInUser, RootGettersReturns } from '@/store/types';
import { StageActionsKeys, StageActionsPayload } from '@/store/types/stageState';

@Component({})
export default class OnlineUsers extends Vue {
  @Getter sessionUsers!: RootGettersReturns['sessionUsers'];
  @Getter currentUser!: RootGettersReturns['currentUser'];
  @Getter raisedHand!: RootGettersReturns['raisedHand'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter laserOfferedTo!: RootGettersReturns['laserOfferedTo'];

  @Action(StageActionsKeys.OFFER_POINTER) offerPointer!: (payload: StageActionsPayload['OFFER_POINTER']) => void;
  @Action(StageActionsKeys.TAKEAWAY_POINTER) takeawayPointer!: () => void;

  showMenu = false;
  showMenuUser: boolean | number = false;

  get users() {
    const currentUser = this.currentUser;
    if (!currentUser) return [];
    const currentUserInAllUsers = this.sessionUsers.find(u => u.id === currentUser.id);
    const user = { ...currentUser, ...currentUserInAllUsers, fullName: `${currentUser.fullName} (You)` };
    const allUsers = [user, ...this.sessionUsers.filter(u => u.id !== currentUser.id)];
    return allUsers.map(u => {
      return { ...u, raised: this.raisedHand.includes(u.id) };
    });
  }

  doesHaveLaser(user: LoggedInUser) {
    return this.hasOfferedLaser(user) && this.laserOfferedTo.isAccepted;
  }

  hasOfferedLaser(user: LoggedInUser) {
    return user.id === this.laserOfferedTo.user?.id;
  }

  laserText(user: LoggedInUser) {
    return this.hasOfferedLaser(user) ? 'Disable Pointer' : 'Laser Pointer';
  }

  laserAction(user: LoggedInUser) {
    if (this.hasOfferedLaser(user)) {
      this.takeawayPointer();
    } else {
      this.offerPointer(user);
    }
  }

  async openMenu(e: Event, user: LoggedInUser) {
    e.preventDefault();
    this.showMenu = false;
    this.showMenuUser = user.id;

    await this.$nextTick();
    this.showMenu = true;
  }
}
